import apiClient from "../apiClient";

// Comprehensive Compliance Reminders Service
const complianceRemindersService = {
  // Get compliance metrics dashboard
  getComplianceMetrics: async () => {
    try {


      // Use the new aggregated API endpoint
      const response = await apiClient.get("/compliance-aggregated/metrics");
      const metrics = response.data || {};



      return metrics;
    } catch (error) {

      // Return empty metrics on error
      return {
        totalCompliance: { current: 0, previous: 0, target: 95.0 },
        overdueItems: { current: 0, previous: 0, target: 0 },
        upcomingDeadlines: { current: 0, previous: 0, target: 10 },
        completedThisMonth: { current: 0, previous: 0, target: 25 },
      };
    }
  },

  // Get upcoming compliance reminders
  getUpcomingReminders: async (filters = {}) => {
    try {





      // Use the new aggregated API endpoint
      const response = await apiClient.get("/compliance-aggregated/upcoming", {
        params: filters,
      });

      const reminders = response.data || [];






      return reminders;
    } catch (error) {

      return [];
    }
  },

  // Get completed compliance items
  getCompletedItems: async (filters = {}) => {
    try {


      // Use the new aggregated API endpoint
      const response = await apiClient.get("/compliance-aggregated/completed", {
        params: filters,
      });

      const completedItems = response.data || [];





      return completedItems;
    } catch (error) {

      return [];
    }
  },

  // Get compliance categories breakdown
  getComplianceCategories: async () => {
    try {


      // Use the new aggregated API endpoint
      const response = await apiClient.get("/compliance-aggregated/categories");
      const categories = response.data || [];






      return categories;
    } catch (error) {

      return [];
    }
  },

  // Get compliance details by ID
  getComplianceById: async (id) => {
    try {


      // Use the new aggregated API endpoint
      const response = await apiClient.get(`/compliance-aggregated/${id}`);
      const compliance = response.data;






      return compliance;
    } catch (error) {

      throw error;
    }
  },

  // Create new compliance reminder
  createComplianceReminder: async (reminderData) => {
    try {


      const response = await apiClient.post(
        "/policies/compliance-tasks",
        reminderData
      );
      return response.data;
    } catch (error) {

      throw error;
    }
  },

  // Update compliance reminder
  updateComplianceReminder: async (reminderId, reminderData) => {
    try {


      const response = await apiClient.put(
        `/policies/compliance-tasks/${reminderId}`,
        reminderData
      );
      return response.data;
    } catch (error) {

      throw error;
    }
  },

  // Complete compliance task
  completeComplianceTask: async (taskId, completionData) => {
    try {


      const response = await apiClient.post(
        `/policies/compliance-tasks/${taskId}/complete`,
        completionData
      );
      return response.data;
    } catch (error) {

      throw error;
    }
  },

  // Get compliance analytics
  getComplianceAnalytics: async (period = "current-month") => {
    try {


      // Use the new aggregated API endpoint
      const response = await apiClient.get("/compliance-aggregated/metrics");
      const metrics = response.data || {};





      return metrics;
    } catch (error) {

      return {
        totalCompliance: { current: 0, previous: 0, target: 95.0 },
        overdueItems: { current: 0, previous: 0, target: 0 },
        upcomingDeadlines: { current: 0, previous: 0, target: 10 },
        completedThisMonth: { current: 0, previous: 0, target: 25 },
      };
    }
  },
};

// Helper functions are now handled by the aggregated API backend

export default complianceRemindersService;
